module.exports = __webpack_public_path__ + "Sacramento-Regular.66b0e223824fd123ab07.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/font/Sacramento-Regular.ttf
// module id = ../../../../../src/assets/font/Sacramento-Regular.ttf
// module chunks = styles